import { FiHome, FiUsers, FiDollarSign } from "react-icons/fi";

export const linkItems = [
  { name: "Beranda", icon: FiHome, href: "/" },
  { name: "Kasbon", icon: FiDollarSign, href: "/kasbon" },
  { name: "Manajemen Pengguna", icon: FiUsers, href: "/manajemen-pengguna" },
];
